import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { signInWithGoogle } from '../../lib/auth.service';
import toast from 'react-hot-toast';

interface GoogleSignInButtonProps {
  className?: string;
  onError?: (error: Error) => void;
}

const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({ className = '', onError }) => {
  const [loading, setLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    try {
      setLoading(true);
      console.log('Initiating Google sign in');
      
      const { data, success } = await signInWithGoogle();
      
      if (!success) {
        throw new Error('Failed to initiate Google sign in');
      }
      
      console.log('Google sign in initiated, redirecting...', data);
      // No need for toast here as the user will be redirected to Google
    } catch (error) {
      console.error('Google sign in error:', error);
      toast.error('Failed to sign in with Google');
      if (onError) {
        onError(error as Error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      className={`w-full justify-center ${className}`}
      onClick={handleGoogleSignIn}
      disabled={loading}
    >
      {loading ? (
        <>
          <span className="loader mr-2" />
          Signing in...
        </>
      ) : (
        <>
          <img 
            src="https://www.google.com/favicon.ico"
            alt=""
            className="h-5 w-5 mr-2"
          />
          Continue with Google
        </>
      )}
    </Button>
  );
};

export default GoogleSignInButton;